/**
 * SASADM-0173 — the standalone-hostname input rules shared by `CustomHostnameDialog` (SASADM-0171)
 * and `AddHostnameDialog`: normalization, the client-side shape check, and the on-white-label /
 * system-URL refusals. The server stays the authority (INVALID_HOSTNAME, HOSTNAME_ALREADY_REGISTERED).
 */
import { isOnDomain } from './whitelabelShared';

type CopyFunction = (
  key: string,
  fallback?: string,
  values?: Record<string, string | number>,
) => string;

const HOSTNAME_RE = /^[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)+$/;

/** The hostname as validated and sent: trimmed, lower-case. */
export function normalizeHostname(value: string): string {
  return value.trim().toLowerCase();
}

/** The field's client error for a normalized hostname, or null when it may be sent. */
export function validateStandaloneHostname(
  host: string,
  wlDomainName: string | null,
  systemHostnames: string[],
  t: CopyFunction,
): string | null {
  if (!HOSTNAME_RE.test(host)) return t('errors.codes.INVALID_HOSTNAME', 'Enter a valid hostname.');
  if (isOnDomain(host, wlDomainName)) {
    return t(
      'hostnames.custom.onWlDomain',
      "That's on the white-label domain — set it in the White-label domain panel above.",
    );
  }
  if (systemHostnames.includes(host)) {
    return t('hostnames.custom.isSystem', "That's one of this tenant's system URLs.");
  }
  return null;
}
